import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Colour from 'components/utils/Colour'
import FormatDateTimeRange from 'components/utils/Formatters/FormatDateTimeRange'
import Group from 'components/utils/Group'
import React from 'react'
import LuxPlusMonthCalendarLogo from './LuxPlusMonthCalendarLogo'
import { LUX_PLUS_MONTH_TAKEOVER_START_DATE, LUX_PLUS_MONTH_TAKEOVER_END_DATE, LUX_PLUS_MONTH_CAMPAIGN_ID } from '../constants/luxPlusMonthTakeoverConstants'
import Places from 'constants/places'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'

const FILTERS: App.OfferListFilters = {
  offerTypes: ['hotel', 'tactical_ao_hotel'],
  luxPlusFeatures: ['Member prices'],
  campaigns: [LUX_PLUS_MONTH_CAMPAIGN_ID],
  destinations: [Places.Anywhere.id],
  sortBy: 'luxPlusList',
  limit: 20,
}

const LUX_PLUS_MONTH_HOTELS_OFFER_CAROUSEL_ALL_LINK = `/search?${getSearchQueryFromFilter(FILTERS)}`

function LuxPlusMonthTakeoverSearchBanner() {
  return <Group direction="horizontal" gap={20} verticalAlign="center">
    <LuxPlusMonthCalendarLogo />
    <VerticalSpacer gap={2}>
      <Heading variant="heading3">LuxPlus<Colour value="highlight-lux-plus">+</Colour> Month</Heading>
      <BodyText variant="large">
        <Colour value="highlight-lux-plus" as="b">
          <FormatDateTimeRange startValue={LUX_PLUS_MONTH_TAKEOVER_START_DATE} endValue={LUX_PLUS_MONTH_TAKEOVER_END_DATE} day="numeric" month="long" />
        </Colour>
        {' '}
        More savings, more hidden offers, more exclusive benefits.
        {' '}
        <TextLink to={LUX_PLUS_MONTH_HOTELS_OFFER_CAROUSEL_ALL_LINK} wrap="no-wrap">View all offers</TextLink>
      </BodyText>
    </VerticalSpacer>
  </Group>
}

export default LuxPlusMonthTakeoverSearchBanner
